import * as types from "../constants/ActionTypes";
import { INITIAL_STATE } from "../constants/AppConstants";

const modifyDataReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.POST_DATA_SUCCESS:
      return Object.assign({}, state, action.value);
    case types.PRINT_TAG_REQUEST:
      return Object.assign({}, state, action.value);
    case types.PRINT_REQUEST:
      return Object.assign({}, state, action.value);
    case types.PRINT_SUCCESS:
      return Object.assign({}, state, action.value);
    case types.PRINT_ERROR:
      return Object.assign({}, state, action.value);
    case types.PRINT_TAG_SUCCESS:
      return Object.assign({}, state, action.value);
    case types.PRINT_TAG_ERROR:
      return Object.assign({}, state, action.value);
    default:
      return state;
  }
};

export default modifyDataReducer;
